require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./manufacturing-edam-2-3-4-0.json") })
        }
      }, "path---manufacturing-edam-2-3-4-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---manufacturing-edam-2-3-4-0!./.cache/json/manufacturing-edam-2-3-4-0.json
// module id = 488
// module chunks = 231608221292675